/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_TWITTER': {
    width: 16,
    height: 16,
    viewBox: '0 0 17 14',
    data: '<path pid="0" d="M16.72 1.83a6.55 6.55 0 0 1-1.94.53A3.39 3.39 0 0 0 16.27.47a6.77 6.77 0 0 1-2.15.83A3.35 3.35 0 0 0 11.66.22a3.4 3.4 0 0 0-3.28 4.2 9.53 9.53 0 0 1-7-3.57 3.47 3.47 0 0 0 1.09 4.57A3.34 3.34 0 0 1 .94 5a3.41 3.41 0 0 0 2.71 3.4 3.41 3.41 0 0 1-1.53.06 3.37 3.37 0 0 0 3.15 2.37 6.66 6.66 0 0 1-5 1.42 9.44 9.44 0 0 0 5.17 1.54A9.63 9.63 0 0 0 15 3.6a7.06 7.06 0 0 0 1.68-1.77" _fill="#545454" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_TWITTER.js